import WorkScheduleRegister from '../pages/WorkScheduleRegister';
import WorkResultRegister from '../pages/WorkResultRegister';
import FieldTreeContractorBox from '../pages/FieldTreeContractorBox';
import FieldTreeForm from '../pages/FieldTreeForm';
import FieldTreePartnerBox from '../pages/FieldTreePartnerBox';
import FieldTreePartnerUserForm from '../pages/FieldTreePartnerUserForm';
import { FieldsForm } from '../pages/FieldsForm';
import { FieldsDetail } from '../pages/FieldsDetail';
import { GatePassageRegister } from '../pages/GatePassageRegister';
import { GatePassageEdit } from '../pages/GatePassageEdit';
import { CraneUseRegister } from '../pages/CraneUseRegister';
import { MachineryUseRegister } from '../pages/MachineryUseRegister';
import SafetyDiariesRegister from '../pages/SafetyDiariesRegister';
import SafetyDiariesConfirm from '../pages/SafetyDiariesConfirm';
import { SafetyDiariesBulkRegister } from '../pages/SafetyDiariesBulkRegister';
import { CranesNew } from '../pages/CranesNew';
import { CranesEdit } from '../pages/CranesEdit';
import { MachineriesNew } from '../pages/MachineriesNew';
import { MachineriesEdit } from '../pages/MachineriesEdit';
import { GroupSettingNew } from '../pages/GroupSettingNew';
import { GroupSettingEdit } from '../pages/GroupSettingEdit';
import { SafetyDiariesRecoveryApproval } from '../pages/SafetyDiariesRecoveryApproval';
import { SafetyDiariesRecoveryRegister } from '../pages/SafetyDiariesRecoveryRegister';
import WorkScheduleEdit from '../pages/WorkScheduleEdit';
import WorkResultEdit from '../pages/WorkResultEdit';
import WorkScheduleUnapprovedEdit from '../pages/WorkScheduleUnapprovedEdit';
import WorkResultUnapprovedEdit from '../pages/WorkResultUnapprovedEdit';
import { SubcontractReNotifyDetail } from '../pages/SubcontractReNotifyDetail';
import { WorkLedgerDetail } from '../pages/WorkLedgerDetail';
import { SubcontractorsTable } from '../pages/SubcontractorsTable';
import { LwApiSettingRegister } from '../pages/LwApiSettingRegister'; // LINE WORKS 連携情報登録/詳細・編集
import { LwGroups } from '../pages/LwGroups';
import { LwTalkrooms } from '../pages/LwTalkrooms';
import { ProgressSelectWorkType } from '../pages/ProgressSelectWorkType';
import { DirectApiSettingRedirect } from '../pages/DirectApiSettingRedirect'; // LINE WORKS 連携情報登録/詳細・編集

//スライドのコンポーネント一覧を定義
//作業予定新規フォーム

//施工体系図 元請けBOX
export class ContractorBox extends FieldTreeContractorBox { }

//施工体系図 元請け新規登録フォーム
export class FieldTreeNew extends FieldTreeForm { }

//施工体系図 協力会社Box
export class PartnerBox extends FieldTreePartnerBox { }

//施工体系図 協力会社ユーザーフォーム
export class PartnerUserForm extends FieldTreePartnerUserForm { }

export {
  FieldsForm, // 現場一覧 (編集) or 新規現場承認/否認 (編集)
  FieldsDetail, // 現場一覧 (詳細) or 新規現場承認/否認 (詳細)
  GatePassageRegister, //ゲート予定フォーム
  GatePassageEdit,
  //作業予定フォーム
  WorkScheduleRegister,
  WorkResultRegister,
  CraneUseRegister, // 揚重機予定フォーム
  MachineryUseRegister, // 機材予定フォーム
  SafetyDiariesRegister,
  SafetyDiariesConfirm,
  SafetyDiariesBulkRegister,
  CranesNew,
  CranesEdit,
  MachineriesNew,
  MachineriesEdit,
  GroupSettingNew, // グループ設定 (新規)
  GroupSettingEdit, // グループ設定 (編集)
  SafetyDiariesRecoveryApproval,
  SafetyDiariesRecoveryRegister,
  WorkScheduleEdit,
  WorkResultEdit,
  WorkScheduleUnapprovedEdit,
  WorkResultUnapprovedEdit,
  SubcontractReNotifyDetail, // 再下請負通知書 詳細画面
  WorkLedgerDetail, // 施工体系台帳 詳細画面
  SubcontractorsTable, // 下請負業者編成表 詳細画面
  LwApiSettingRegister, // LINE WORKS 連携情報登録/詳細・編集
  LwGroups,
  LwTalkrooms,
  ProgressSelectWorkType,
  DirectApiSettingRedirect,
};



// WEBPACK FOOTER //
// ./src/utilities/slideComponents.js